import { getBaseURL, getEnv } from './util/environment';
import global from 'core-sdk/lib/global/globalConfig';

const isDev = getEnv() === 'dev';
const baseURL = getBaseURL();

// Experian added params for click tracking
const experianClickTrackingParamsMap = {
    clickId: 'partnerExternalReference',
    trackId: 'partnerCustomerId'
};
// credit karma light box params for campaign beginning in spring 2024
const creditKarmaLightBoxParamsMap = {
    ckanonid: 'ckanonid',
    lbamount: 'lbamount',
    lbterm: 'lbterm',
    lbapr: 'lbapr',
    lbi: 'lbi',
    lbown: 'lbown',
    lbhp: 'lbhp',
    lblp: 'lblp',
    model: 'model',
    approvingmodelid: 'approvingmodelid',
    campaign: 'campaign'
};

const referralParamsMap = {
    r: 'referredBy',
    c: 'campaignReferral',
    p: 'partnerReferral',
    m: 'partnerCustomerId',
    keyword: 'keyword',
    adposition: 'adposition',
    creative: 'creative',
    device: 'device',
    location: 'location',
    matchtype: 'matchtype',
    target: 'target',
    network: 'network',
    placement: 'placement',
    ...creditKarmaLightBoxParamsMap,
    ...experianClickTrackingParamsMap
};

const queryParamsMap = {
    ...referralParamsMap,
    iat: 'iat',
    id: 'id',
    loanPurpose: 'loanPurpose',
    token: 'token',
};

const searchPartners = ['google', 'bing', 'yahoo', 'ask'];
const five9Config = {
    type: 'chat',
    rootUrl: 'https://app.five9.com/consoles/',
    tenant: 'RocketLoans',
    showProfiles: false,
};

const rocketAccountGlobalPreferenceCenterRoot = 'https://preferences' + (getEnv() === 'www' ? '' : '.beta') + '.myrocket.com/profile/security';

const rocketAccountBase = 'https://' + (getEnv() === 'www' ? 'www' : 'beta') + '.rocketaccount.com/#';
const webUIRoot = `${window.location.protocol}//${baseURL}`;
const pingAppUrl = `${webUIRoot}/ping-app#/`;
const linkPage = `${pingAppUrl}link`;

const config = {
    global,
    landingPagePath: '/inq',
    linkPage,
    baseName: '/inq/index.html#/',
    coreApiUrl: `//${isDev ? '' : 'api.'}${baseURL}/api/`,
    webUIRoot,
    appUIRoot: 'index.html#/',
    webUIUrl: `${webUIRoot}/app#/`,
    pingAppUrl,
    rocketAccountLoginUrl: linkPage,
    rocketAccountLogoutUrl: webUIRoot + '?logout=true',
    rocketAccountSplitScreenLoginUrl: `${webUIRoot}/app#/upgrade-login`,
    rocketAccountGlobalPreferenceCenterUrl: rocketAccountGlobalPreferenceCenterRoot + '?gpc_origin=' + encodeURIComponent(pingAppUrl),
    rocketAccountCreateAccountUrl: rocketAccountBase + '/create-account?redirect=' + encodeURIComponent(linkPage) + '&metricIdentifiers=%7B%22rocketAccountIntent%22:%22rocketloans%22%7D',
    rocketAccountMergeAccountUrl: rocketAccountBase + '/rocket-loans/sign-in',
    rocketAccountRegisteredAccountExistsUrl: `${webUIRoot}/inq/index.html#/account-exists`,
    loanMin: 2000,
    loanMax: 45000,
    googleMapsKey: 'AIzaSyCDlrleFxR3OnZlfvDKOCPgTOjnBTW3U5M',
    googleSiteKey: '6Lemcw0TAAAAAOaXXIi2pxFXfhCrbB33SjAVSqNy',
    queryParamsMap,
    referralParamsMap,
    searchPartners,
    five9Config,
};

window.globalConfig = global;

export default config;
